/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropDown from 'app/components/common/DropDown.jsx';
import FeedConfigurePanel from 'app/components/EditorComponents/FeedConfigurePanel.jsx';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import FacebookPageConfigPanel from 'app/components/EditorComponents/FacebookPageConfigPanel.jsx';
import TikTokInputConfigPanel from 'app/components/EditorComponents/TikTokInputConfigPanel.jsx';
import YouTubeInputConfigPanel from 'app/components/EditorComponents/YouTubeInputConfigPanel.jsx';
import InputEditorButtons from 'app/mixins/InputEditorButtonsMixin.js';
import ButtonList from 'app/components/common/ButtonList.jsx';
import EchoComponent from 'app/components/EditorComponents/EchoComponent.jsx';
import * as _ from 'underscore';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import axios from 'axios';

/*
 * The configure step's subtitle for the four sources connected over OAuth,
 * which is where this component dispatches. Undefined for anything else, so
 * AutomationShell falls back to its own generic line rather than to whichever
 * source happened to be drawn first.
 *
 * A module function rather than a static on the class: the default export is
 * the ComponentWithContext wrapper, which is a plain function component and so
 * carries none of the class's statics.
 */
export function configureSubtitle(input, constants) {
    let subtitles = {};

    subtitles[constants.INPUT_TYPE_YOUTUBE]             = "Choose which videos we'll post.";
    subtitles[constants.INPUT_TYPE_TIKTOK]              = "Choose which videos we'll post.";
    subtitles[constants.INPUT_TYPE_FACEBOOK_PAGE]       = "Choose which posts we'll share.";
    subtitles[constants.INPUT_TYPE_INSTAGRAM_BUSINESS]  = "Choose which posts we'll share.";
    subtitles[constants.INPUT_TYPE_INSTAGRAM]           = "Choose which posts we'll share.";

    return (input) ? subtitles[parseInt(input.type)] : undefined;
}

class CreateFeedConfigure extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            preview: null,
            previewError: null
        };
    }

    render() {
        // there should only be a single input - this configure shown for
        // simple route view
        let constants = this.props.app.config.constants,
            Config = '',
            buttons = null,
            {children, ...otherProps} = this.props,
            validationErrors = null,
            validationErrorDisplay = null;

        validationErrors = this.props.getApiErrors(['INPUT_VALIDATE']);
        if (validationErrors.length) {
            let error = validationErrors[0],
                errorMsg = '';

            if (error.errors.perms !== undefined) {
                errorMsg = error.errors.perms.msg;
            } else if (error.errors.validation) {
                errorMsg = "Sorry, we're unable to validate this input configuration.";
            }
            validationErrorDisplay = (
                <div className="detail-status error">
                    {errorMsg}
                </div>
            );
        }

        if (this.props.router.location.pathname.match(/new\/configure$/)) {
            switch (parseInt(this.props.input.type, 10)) {
                case constants.INPUT_TYPE_FEED:
                    Config = (
                        <FeedConfigurePanel
                            {...this.props}
                            input={this.props.input}
                    		textRuleHandler={this.props.textRuleHandler}
                    		scheduleHandler={this.props.scheduleHandler}
                            context="onboarding"
                            statePath={this.props.statePath} />
                    );
                    break;

                case constants.INPUT_TYPE_TWITTER:
                    // don't show twitter fields since we got the account/list/favorites data
                    // in a prior step
                    Config = (
                        <TwitterInputConfigPanel
                                {...this.props}
                                input={this.props.input}
                                textRuleHandler={this.props.textRuleHandler}
                                scheduleHandler={this.props.scheduleHandler}
                                statePath={this.props.statePath}
                                showTwitterFields={false} />
                    );
                    break;

                case constants.INPUT_TYPE_INSTAGRAM:
                case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                    Config = (
                        <InstagramConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath}
                            replayPromo={null} />
                    )
                    break;

                case constants.INPUT_TYPE_FACEBOOK_PAGE:
                    Config = (
                        <FacebookPageConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath} />
                    );
                    break;

                case constants.INPUT_TYPE_TIKTOK:
                    Config = (
                        <TikTokInputConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath} />
                    );
                    break;

                case constants.INPUT_TYPE_YOUTUBE:
                    Config = (
                        <YouTubeInputConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath} />
                    );
                    break;

                default:
                    break;
            }
        } else {
            buttons = InputEditorButtons.getButtons.apply(this, ['/share/automate/new/configure/input']);
            Config = (
                <div>
                    <ButtonList
                        buttons={buttons}
						wrapperClass="editor-tabs"
						linkClass="editor-tab-item"
						activeClass="tab-active"
						errorClass="tab-error" />
                    <Outlet context={otherProps}/>
                </div>
            );
        }

        return (
            <div>
                {validationErrorDisplay}
                {Config}
            </div>
        );

    }

};

CreateFeedConfigure.displayName = "CreateFeedConfigure";

CreateFeedConfigure.propTypes = {
    input: PropTypes.object,
    changeHandler: PropTypes.func,
    textRuleHandler: PropTypes.func,
    scheduleHandler: PropTypes.func,
    statePath: PropTypes.string,
};

CreateFeedConfigure.defaultProps = {
    input: {},
    changeHandler: () => {},
    textRuleHandler: () => {},
    scheduleHandler: () => {},
    statePath: 'input',
};

export default ComponentWithContext(CreateFeedConfigure);
